import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { ManualInvoiceOrigin } from '@/pages/InvoicesPage.types'

export function InvoiceCategorySelect({
  value,
  onChange,
  defaultOpen = false,
  disabled = false,
  onClose,
}: {
  value: ManualInvoiceOrigin
  onChange: (value: ManualInvoiceOrigin) => void
  defaultOpen?: boolean
  disabled?: boolean
  onClose?: () => void
}) {
  return (
    <Select
      value={value}
      onValueChange={(next) => onChange(next as ManualInvoiceOrigin)}
      defaultOpen={defaultOpen}
      disabled={disabled}
      onOpenChange={(open) => {
        if (!open) onClose?.()
      }}
    >
      <SelectTrigger aria-label="Category">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="manual">Other</SelectItem>
        <SelectItem value="sponsorship">Sponsorship</SelectItem>
        <SelectItem value="training">Training</SelectItem>
      </SelectContent>
    </Select>
  )
}
